<template lang="html">
  <v-container fluid>
    <v-row v-if="hasPermission('Material API READ')">
      <v-col xs12 md8>
        <v-card>
          <v-card-title>
            Material
            <v-spacer></v-spacer>
            <TSearchField
            height="40px"
            width="50vw"
            style="margin:auto"
            color="#757575"
            border_color="rgb(41,41,41)"
            placeholder="Search Material by name"
            :value="material_search"
            @input="requestMaterials($event.target.value)"
            @cancel="material_search = ''"
              />
          </v-card-title>
          <v-data-table
          :headers="headers"
          :items="getMaterial"
          :sort-by="[]"
          :sort-desc="[false, true]"
          single-select
          multi-sort
          class="elevation-1"
          items-per-page=4
          >
        </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
import TSearchField from '@/components/Taktify/TSearchField.component.vue';

export default {
  name: 'MaterialAPIDashboard',
  components: {
    TSearchField
  },
  data: function () {
    return {
      material_search: '',
      headers: [
        { text: 'Name (en)', value: 'Name (en)' },
        { text: 'Name (de)', value: 'Name (de)' },
        { text: 'ADPE', value: 'ADPE' },
        { text: 'ADPF', value: 'ADPF' },
        { text: 'AP', value: 'AP' },
        { text: 'Bezugseinheit', value: 'Bezugseinheit' },
        { text: 'Bezugsgroesse', value: 'Bezugsgroesse' },
        { text: 'Declaration owner', value: 'Declaration owner' },
        { text: 'EP', value: 'EP' },
        { text: 'FW', value: 'FW' },
        { text: 'Flaechengewicht', value: 'Flaechengewicht' },
        { text: 'GWP', value: 'GWP' },
        { text: 'Gueltig bis', value: 'Gueltig bis' },
        { text: 'HWD', value: 'HWD' },
        { text: 'Kategorie (en)', value: 'Kategorie (en)' },
        { text: 'Kategorie (original)', value: 'Kategorie (original)' },
        { text: 'Konformität', value: 'Konformität' },
        { text: 'Laenderkennung', value: 'Laenderkennung' },
        { text: 'Modul', value: 'Modul' },
        { text: 'NHWD', value: 'NHWD' },
        { text: 'NRSF', value: 'NRSF' },
        { text: 'Kategorie', value: 'Kategorie' },
        { text: 'ODP', value: 'ODP' },
        { text: 'PENRE', value: 'PENRE' },
        { text: 'PENRM', value: 'PENRM' },
        { text: 'PENRT', value: 'PENRT' },
        { text: 'PERE', value: 'PERE' },
        { text: 'PERM', value: 'PERM' },
        { text: 'PERT', value: 'PERT' },
        { text: 'POCP', value: 'POCP' },
        { text: 'RSF', value: 'RSF' },
        { text: 'RWD', value: 'RWD' },
        { text: 'Referenzfluss-Name', value: 'Referenzfluss-Name' },
        { text: 'Referenzfluss-UUID', value: 'Referenzfluss-UUID' },
        { text: 'Referenzjahr', value: 'Referenzjahr' },
        { text: 'SM', value: 'SM' },
        { text: 'Schichtdicke (m)', value: 'Schichtdicke (m)' },
        { text: 'Typ', value: 'Typ' },
        { text: 'URL', value: 'URL' },
        { text: 'UUID', value: 'UUID' },
        { text: 'Version', value: 'Version' },
      ]
    }
  },
  computed: {
    ...mapGetters('Material', [
      'getMaterial',
    ]),
    ...mapGetters('Auth', [
      'hasPermission',
    ]),
  },
  methods: {
    ...mapActions('Material', [
      'requestMaterials',
    ]),
  }
}
</script>

<style lang="css" scoped>
.application-reason {
  width: 100%;
  border-radius: 5px;
  padding: 3px;
}
</style>
